import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './schools-disclaimer.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var SchoolsDisclaimer = function SchoolsDisclaimer() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    show = _ref.show,
    onClose = _ref.onClose,
    governmentCopyright = _ref.governmentCopyright;
  return ___EmotionJSX(Modal, {
    show: show,
    title: "Disclaimer (School Search)",
    mobileStyle: "75perc",
    onClose: onClose
  }, ___EmotionJSX("div", {
    css: styles.disclaimerContentContainer
  }, ___EmotionJSX("p", {
    css: styles.disclaimerContentPara
  }, "All data and information relating to local schools is provided by Allhomes as a courtesy only. Allhomes does not make any representations or warranties regarding the accuracy and/or completeness of this data and information. Users should check directly with the local schools to verify this data and/or information."), ___EmotionJSX("p", {
    css: styles.disclaimerContentPara
  }, "\xA9 ACARA. Licensed under the", ' ', ___EmotionJSX("a", {
    href: "https://creativecommons.org/licenses/by/4.0/",
    target: "_blank",
    rel: "noopener"
  }, "Creative Commons Attribution 4.0 International license"), "."), /* eslint-disable react/no-danger */
  ___EmotionJSX("p", {
    css: styles.disclaimerContentPara,
    dangerouslySetInnerHTML: {
      __html: governmentCopyright
    }
  })
  /* eslint-enable react/no-danger */));
};
SchoolsDisclaimer.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  governmentCopyright: PropTypes.string
};
SchoolsDisclaimer.defaultProps = {
  onClose: () => {},
  governmentCopyright: ''
};
export default SchoolsDisclaimer;